/**
 * schemas/common.ts — ชิ้นส่วน schema ที่ใช้ซ้ำ
 */
import { z } from 'zod';
/** ข้อความที่ตัดช่องว่างหัวท้ายและยอมให้ว่างได้ (ระบบเดิมใช้ '' แทน null เยอะ) */
export const optionalText = (max = 500) => z
    .string()
    .trim()
    .max(max)
    .optional()
    .default('')
    .transform((value) => value ?? '');
export const requiredText = (label, max = 500) => z.string({ required_error: `กรุณากรอก${label}` }).trim().min(1, `กรุณากรอก${label}`).max(max);
/** จำนวนเงินบาท ไม่ติดลบ ทศนิยมไม่เกิน 2 ตำแหน่ง */
export const money = z
    .number()
    .finite('จำนวนเงินไม่ถูกต้อง')
    .min(0, 'จำนวนเงินต้องไม่ติดลบ')
    .max(999_999_999_999.99, 'จำนวนเงินเกินขอบเขตที่ระบบรองรับ');
/** จำนวน (ปริมาณ) มากกว่า 0 */
export const quantity = z
    .number()
    .finite('จำนวนไม่ถูกต้อง')
    .positive('จำนวนต้องมากกว่า 0')
    .max(1_000_000, 'จำนวนเกินขอบเขตที่ระบบรองรับ');
/** อัตรา VAT 0-100 */
export const vatRate = z.number().finite().min(0).max(100);
/**
 * เลขประจำตัวผู้เสียภาษี — เก็บเฉพาะตัวเลข
 * ยอมให้ว่างได้เพราะลูกค้าบุคคลธรรมดาบางรายไม่มี
 */
export const taxId = z
    .string()
    .trim()
    .transform((value) => value.replace(/\D/g, ''))
    .refine((value) => value === '' || value.length === 13, 'เลขผู้เสียภาษีต้องมี 13 หลัก')
    .optional()
    .default('');
/** เลขผู้เสียภาษีที่บังคับ 13 หลัก (ใช้ตอนค้นสรรพากร) */
export const requiredTaxId = z
    .string()
    .trim()
    .transform((value) => value.replace(/\D/g, ''))
    .refine((value) => value.length === 13, 'เลขผู้เสียภาษีต้องมี 13 หลัก');
/** รหัสสาขา 5 หลัก ('00000' = สำนักงานใหญ่) */
export const branchCode = z
    .string()
    .trim()
    .max(20)
    .optional()
    .default('')
    .transform((value) => value ?? '');
/** รับได้ทั้ง Date และ ISO string แล้วแปลงเป็น Date */
export const dateInput = z.coerce.date({
    errorMap: () => ({ message: 'รูปแบบวันที่ไม่ถูกต้อง' }),
});
/** id ที่อ้างถึงเรคอร์ดอื่น — แปลง '' เป็น null ตามพฤติกรรมระบบเดิม */
export const optionalId = z
    .string()
    .trim()
    .nullish()
    .transform((value) => (value === '' || value === undefined ? null : value));
export const cuidLike = z.string().trim().min(1).max(64);
/** พารามิเตอร์แบ่งหน้า — ระบบเดิมไม่มี ทำให้รายการเยอะแล้วช้า */
export const paginationQuery = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(200).default(50),
});
/** ช่วงวันที่สำหรับกรองรายการ */
export const dateRangeQuery = z.object({
    dateFrom: z.coerce.date().optional(),
    dateTo: z.coerce.date().optional(),
});
/** เดือน/ปีสำหรับรายงาน — ค่าเริ่มต้นเป็นเดือนปัจจุบัน */
export const yearMonthQuery = z.object({
    year: z.coerce.number().int().min(2000).max(2100).optional(),
    month: z.coerce.number().int().min(1).max(12).optional(),
});
//# sourceMappingURL=common.js.map